import {getLoanOwnStatusTextByValue} from "../LoanManagement/ownLoanUtility";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";

export const ownLoanHistoryItemModel = ({
                                            ownCatalogItem,
                                            ownCatalogItemId,
                                            ownLoanItemId,
                                            ownLoanNotes,
                                            ownLoanStatus,
                                            ownQueueItem,
                                            ownQueueItemId,
                                            dateCreatedUtc,
                                            dateFulfilledUtc,
                                            dateModifiedUtc,
                                            districtName,
                                            organization,
                                            patron,
                                            patronId,
                                            shippingLocation,
                                            shippingLocationId,
                                        }: Record<string, any> = {}) => ({
    ownCatalogItem,
    ownCatalogItemId,
    ownLoanItemId,
    ownLoanNotes: isNullOrUndefined(ownLoanNotes) ? "" : ownLoanNotes,
    ownLoanStatus,
    ownLoanStatusText: getLoanOwnStatusTextByValue(ownLoanStatus),
    ownQueueItem,
    ownQueueItemId,
    dateCreatedUtc,
    dateFulfilledUtc,
    dateModifiedUtc,
    dateCreatedFormatted: convertDateToPrintString(dateCreatedUtc),
    dateFulfilledFormatted: dateFulfilledUtc ? convertDateToPrintString(dateFulfilledUtc) : "",
    dateModifiedFormatted: convertDateToPrintString(dateModifiedUtc),
    districtName: isNullOrUndefined(districtName) ? "" : districtName,
    organization: isNullOrUndefined(organization) ? "" : organization,
    patron,
    patronId,
    shippingLocation,
    shippingLocationId,
});
